import { combineReducers } from 'redux';
import consignorHome from './consignorHome.reducer';

const rootReducer = () =>
  combineReducers({
    consignorHome
  });

export default rootReducer;
